import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";

export const getHeroes = () => {
  return base.get({
    url: API_PARAM.HEROES,
  });
};
